import { StanddardCp, Maruti, Honda } from '../components/view/index';

const customerControlMap = [
  {
    path: 'Maruti',
    component: StanddardCp,
  },
  {
    path: 'Honda',
    component: StanddardCp,
  },
];

export const getControlPlanAsPerCustomer = (customer_name: any) => {
  const formatName = (customer_name || '').toLowerCase();

  for (const entry of customerControlMap) {
    const regex = new RegExp(entry.path, 'i');
    if (regex.test(formatName)) {
      const ControlPlanComponent = entry.component;
      return ControlPlanComponent;
    }
  }

  // ----x---- default ----x----
  return StanddardCp;
};
